export enum PortalNavServiceReorderEvents {
    ClickedCoreService = 'PortalNavServiceReorderEvents.ClickedCoreService',
    ClickedMoreMenu = 'PortalNavServiceReorderEvents.ClickedMoreMenu',
    ClickedMoreService = 'PortalNavServiceReorderEvents.ClickedMoreService',
    ClickedWaffleMenuToggler = 'PortalNavServiceReorderEvents.ClickedWaffleMenuToggler',
}

type ServiceClickedPayload = {
    service: string;
    fromWaffleMenu: boolean;
    persona: string;
};

type WaffleMenuTogglerClickedPaylaod = {
    opened: boolean;
    persona?: string;
};

type MoreMenuClickedPayload = {
    persona: string;
};

export interface PortalNavEventMap {
    [PortalNavServiceReorderEvents.ClickedCoreService]: ServiceClickedPayload;
    [PortalNavServiceReorderEvents.ClickedMoreMenu]: MoreMenuClickedPayload;
    [PortalNavServiceReorderEvents.ClickedMoreService]: ServiceClickedPayload;
    [PortalNavServiceReorderEvents.ClickedWaffleMenuToggler]: WaffleMenuTogglerClickedPaylaod;
}
